import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/settings_/workflows/$id/')({
  beforeLoad: ({ params }) => {
    // The standalone read-only detail page is gone — the editor renders
    // read-only for stock workflows. Redirect to the editor.
    throw redirect({
      to: '/settings/workflows/$id/edit',
      params: { id: params.id },
    })
  },
})
